import React from "react"
import Service from './transactions.service'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import Pagination from "../../../components/pagination/pagination.component"
import './transactions.styles.scss'

class Transactions extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadTransactions()
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadTransactions()
    }

    toggleShowDelete = transaction => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        transactionToDelete: transaction
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        transactions: this.state.transactions.filter(transaction => transaction.id !== this.state.transactionToDelete.id)
    })

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page,
            loadingTransactions: true
        }, () => this.service.loadTransactions())
    }

    render() {
        return (
            <>
                {(this.state.loadingTransactions || this.state.downloadingReceipt) && <Dialog><Loading /></Dialog>}
                <div className="transactions">
                    <div className="header">
                        <h1>Transaction History</h1>
                        <p>A record of your recent payments and inflows.</p>
                    </div>
                    <div className="section-header">
                        <form className="filter">
                            <div className="row" id="from">
                                <div className="form-label">
                                    <label>From</label>
                                </div>
                                <div className="form-input">
                                    <input type="date" name="from" onChange={this.onFilterChange} value={this.state.criteria.from} />
                                </div>
                            </div>
                            <div className="row" id="from">
                                <div className="form-label">
                                    <label>To</label>
                                </div>
                                <div className="form-input">
                                    <input type="date" name="to" onChange={this.onFilterChange} value={this.state.criteria.to} />
                                </div>
                            </div>
                            <div className="row">
                                <button type="submit" onClick={this.onFilterSubmit}>Apply</button>
                            </div>
                        </form>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Reference</th>
                                <th>Description</th>
                                <th>Credit(₦)</th>
                                <th>Debit(₦)</th>
                                <th>Created</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.transactions.map((transaction, key) => <tr key={key}>
                                    <td>{transaction.reference}</td>
                                    <td>{transaction.description}</td>
                                    <td>{transaction.credit}</td>
                                    <td>{transaction.debit}</td>
                                    <td>{new Date(transaction.created).toString("dd MMM yyyy HH:mm:ss")}</td>
                                    <td><button onClick={() => this.service.downloadReceipt(transaction.reference)}>Receipt</button></td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.totalItems > 0 && <Pagination totalItemsCount={this.state.totalItems} currentIndex={this.state.currentPage} itemsPerPage={this.state.itemsPerPage} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Transactions))